import {useCallback, ReactElement} from 'react';
import {useNavigate, useUrl} from '@shopify/hydrogen';
import {useSearchUI} from '../contexts/SearchUIProvider.client';
import {useShopFilterUrlEncode} from '../hooks/useShopFilterUrlEncode.client';
import coerceIsTrue from '../utils/coerceIsTrue';
import {getSearchQuery} from '../utils/shopFilterHelpers';

export default function ShopSearchTokens(): ReactElement {
  const {filterParams} = useShopFilterUrlEncode();
  const {href} = useUrl();
  const {openSearch, setInTwlShop, setIncludeOutOfStock} = useSearchUI();

  const navigate = useNavigate();

  const removeToken = useCallback(
    (position: number) => {
      navigate(
        `/shop?${getSearchQuery(href, {
          ...filterParams,
          ...{
            searchTokens: filterParams.searchTokens.filter(
              (_, index) => index !== position,
            ),
          },
        })}`,
      );
    },
    [filterParams, href, navigate],
  );

  if (filterParams.searchTokens.length === 0) {
    return <></>;
  }

  const {inStock, inTwlShop} = filterParams;
  return (
    <div className="rc container mt-30">
      <div
        role="button"
        tabIndex={-1}
        onClick={openSearch}
        className="rc__title title-3 c-dark-gray"
      >
        Search results for{' '}
      </div>
      {filterParams.searchTokens.map((token, index) => (
        <div key={token} className="rc__item">
          <div className="rc__name">{token}</div>
          <div
            role="button"
            tabIndex={-1}
            onClick={() => removeToken(index)}
            className="rc__remove close-custom"
          ></div>
        </div>
      ))}

      <div
        role="button"
        tabIndex={-1}
        onClick={() => {
          openSearch();
          setInTwlShop(coerceIsTrue(inTwlShop));
          setIncludeOutOfStock(coerceIsTrue(inStock, ['any']));
        }}
        className="rc__extra-action"
      >
        Refine
      </div>
    </div>
  );
}
